import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import PortfolioItemWithGroupsPromptVariant from '../PortfolioItemWithGroupsPrompt/PortfolioItemWithGroupsPromptVariant.enum';
import PortfolioItemWithGroupsPrompt, {
  type PortfolioItemWithGroupsPromptProps,
} from '../PortfolioItemWithGroupsPrompt';

type PartPromptWithGroupsProps = Omit<
  PortfolioItemWithGroupsPromptProps,
  'variant' | 'label' | 'createsItem' | 'children'
>;

const PartPromptWithGroups = (props: PartPromptWithGroupsProps) => (
  <PortfolioItemWithGroupsPrompt
    variant={PortfolioItemWithGroupsPromptVariant.PART}
    label={
      <FormattedMessage id="portfolio_template_editor.add_part.input_label" />
    }
    createsItem
    {...props}
  >
    <Dialog.Title>
      <FormattedMessage id="portfolio_template_editor.add_part.title" />
    </Dialog.Title>
    <Dialog.Content>
      <Dialog.ContentText>
        <FormattedMessage id="portfolio_template_editor.add_part.text" />
      </Dialog.ContentText>
    </Dialog.Content>
  </PortfolioItemWithGroupsPrompt>
);

export default PartPromptWithGroups;
